import { useEffect, useState } from "react";
import * as S from './styles';

export const Whistleblowing = () => {
  const [sending, setSending] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const EMAIL_ENDPOINT = "https://functions-delivery.azurewebsites.net/api/enviar?code=DotNdS_84nOgt83pNs6Bwgz9u58tBx-GioQT_odEmKTMAzFua3IXag==";

  async function sendEmailReact({ name, email, phone, message }) {
    const payload = {
      de: "no-reply@bindflow.com.br",
      para: "denuncia@bindflow.com.br",
      assunto: "Canal de Denúncias",
      corpo: `${name} <br />${email} <br />${phone} <br />${message}`
    };

    try {
      const response = await fetch(EMAIL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const text = await response.text();

      if (!response.ok) {
        throw new Error(text || "Falha ao enviar email");
      }

      return { ok: true };
    } catch (error) {
      return { ok: false, message: error.message };
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSending(true);

    const form = e.currentTarget;

    const name = form.name.value;
    const email = form.email.value;
    const phone = form.phone.value;
    const message = form.message.value;

    const result = await sendEmailReact({ name, email, phone, message });

    setSending(false);

    if (result.ok) {
      form.reset();
      alert("Mensagem enviada com sucesso!");
    } else {
      alert("Erro ao enviar: " + result.message);
    }
  }

  return (
    <S.Wrapper>
      <S.PageTitle>Canal de Denúncias</S.PageTitle>

      <S.ContentBox>
        <S.Form onSubmit={handleSubmit} noValidate>
          <S.Field>
            <label htmlFor="name">Nome</label>
            <S.Input id="name" name="name" required />
          </S.Field>

          <S.Field>
            <label htmlFor="email">Email</label>
            <S.Input id="email" name="email" type="email" inputMode="email" required />
          </S.Field>

          <S.Field>
            <label htmlFor="phone">Telefone</label>
            <S.Input id="phone" name="phone" type="tel" inputMode="tel" />
          </S.Field>

          <S.Field>
            <label htmlFor="message">Mensagem</label>
            <S.Textarea id="message" name="message" rows={5} required />
          </S.Field>

          <S.ActionBtn type="submit" disabled={sending}>
            {sending ? "Enviando…" : "Enviar Mensagem"}
          </S.ActionBtn>
        </S.Form>

      </S.ContentBox>
    </S.Wrapper>
  );
};
